const distances = {
  pageMarginBig: 80,
  gap: 30,
  sectionMarginBig: 90,
};

export default distances;
